import React from 'react';
import { uniq } from 'ramda';

import { LINK } from 'constants/regexp';

const getLink = (url) => `<a href="${url}">${url}</a>`;

const getEscapedUrl = (url) => url.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");

const getRegExp = (url) => new RegExp(getEscapedUrl(url), 'g');

export default function HighlightedLinks ({ text }) {
    if (!text) {
        return text;
    }

    const matches = uniq(text.match(LINK) || []);

    let result = text;
    matches.forEach(url => {
        result = result.replace(getRegExp(url), getLink(url));
    });

    return (
        <span dangerouslySetInnerHTML={{ __html: result }} />
    );
}
